import VueRouter, { RouteConfig } from 'vue-router'

const Index = () => import('./spring-new-term/index.vue')
const Records = () => import('./spring-new-term/SendRecords.vue')
const LotteryRecords = () => import('./spring-new-term/LotteryRecords.vue')

export const indexRoute: RouteConfig = {
  path: '/new-term-thomework-2026',
  name: 'new_term_thomework_2026',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '2026新学期中小学体锻指南',
    ignoreLogin: true,
  },
}
export const recordsRoute: RouteConfig = {
  path: '/new-term-thomework-2026-records',
  name: 'new_term_thomework_2026_records',
  component: Records,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '邀请记录',
    ignoreLogin: true,
  },
}
export const lotteryRecordsRoute: RouteConfig = {
  path: '/new-term-thomework-2026-lottery-records',
  name: 'new_term_thomework_2026_lottery_records',
  component: LotteryRecords,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '抽奖记录',
    ignoreLogin: true,
  },
}

export default [indexRoute, recordsRoute, lotteryRecordsRoute]
